import { render } from "./presentercta.vue?vue&type=template&id=2edc9b25&scoped=true"
import script from "./presentercta.vue?vue&type=script&lang=js"
export * from "./presentercta.vue?vue&type=script&lang=js"

import "./presentercta.vue?vue&type=style&index=0&id=2edc9b25&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2edc9b25"

export default script